import { useMemo } from "react";
import { useGeneralPermissions, Result as GeneralResult } from "app/api/graph/hook/use-general-permissions";
import { ReportAccessInformationAttribute } from "app/api/graph/security-attributes";

type Result = GeneralResult & {
    canCreateFile: boolean;
    canCreateCredentials: boolean;
    canViewCredentials: boolean;
};

export const useReportAccessInformationPermissions = (permissions: string[] | null | undefined): Result => {
    const generalResult = useGeneralPermissions(permissions);

    return useMemo(
        () => ({
            ...generalResult,
            canCreateFile: permissions?.includes(ReportAccessInformationAttribute.CanCreateFile) ?? false,
            canCreateCredentials: permissions?.includes(ReportAccessInformationAttribute.CanCreateCredentials) ?? false,
            canViewCredentials: permissions?.includes(ReportAccessInformationAttribute.CanViewCredentials) ?? false,
        }),
        [permissions],
    );
};
